import React from 'react'
import cn from 'classnames'

import Mousetrap from 'components/mousetrap/Mousetrap'

import styles from './input.scss'

export type IInputTypes = 'text' | 'number'

interface IProps {
  className?: string
  innerRef?: React.RefObject<HTMLInputElement>
  style?: React.CSSProperties
  type: IInputTypes
  tabIndex?: number
  value: string | null
  placeholder?: string
  disabled?: boolean
  focusOnMount: boolean
  onChange: (value: string) => void
  onBlur: () => void
  onConfirm?: () => void
  onCancel?: () => void
}

class Input extends React.PureComponent<IProps> {
  static defaultProps = {
    value: '',
    disabled: false,
    focusOnMount: false,
    onChange: () => {},
    onBlur: () => {},
  }

  private input: React.RefObject<HTMLInputElement> = React.createRef()

  componentDidMount() {
    const ref = this.props.innerRef ?? this.input
    if (!ref.current) {
      return
    }

    if (this.props.focusOnMount) {
      ref.current.focus()
    }
  }

  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { disabled, onChange } = this.props
    if (disabled) {
      return
    }

    onChange(e.currentTarget.value)
  }

  handleBlur = () => {
    const { disabled, onBlur } = this.props

    if (!disabled) {
      onBlur()
    }
  }

  render() {
    const {
      className,
      innerRef,
      style,
      type,
      tabIndex,
      value,
      placeholder,
      disabled,
      focusOnMount,
      onChange,
      onBlur,
      onConfirm,
      onCancel,
      ...others
    } = this.props

    const ref = innerRef ?? this.input

    return (
      <div
        className={cn(styles.container, className)}
        style={style}
        {...others}
      >
        <input
          ref={ref}
          lang="en"
          tabIndex={tabIndex}
          className={cn(styles.input, {
            [styles.disabled]: disabled,
          })}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          value={value === null ? '' : value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />

        {/* Shortcuts */}
        {onConfirm && (
          <Mousetrap keys="enter" target={ref} onMatch={onConfirm} />
        )}

        {onCancel && <Mousetrap keys="esc" target={ref} onMatch={onCancel} />}
      </div>
    )
  }
}

export default Input
